function Contact() {
  return (
    <section className="home-page">
      <div className="home-content">
        <h1>Contact</h1>
        <p>email: majcher@gmail.com</p>
      </div>
    </section>
  );
}

export default Contact;
